import {
  ChangeDetectionStrategy,
  Component,
  forwardRef,
  Input,
} from '@angular/core';
import { Nillable } from '@web/utils';
import { MenuItemComponent } from '../menu-item/menu-item.component';
import { MenuItem } from '../../models/menu-item';
import { MenuItemContentTemplateRef } from '../../types/menu-item-content-template-ref';

@Component({
  selector: 'app-menu-item-more-content',
  imports: [forwardRef(() => MenuItemComponent)],
  templateUrl: './menu-item-more-content.component.html',
  styleUrl: './menu-item-more-content.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MenuItemMoreContentComponent {
  @Input({ required: true }) public item!: MenuItem;
  @Input() public contentTemplateRef: Nillable<MenuItemContentTemplateRef>;
}
